/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NotificationModel } from './notification.model';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HandleApiResult, ShowError, ShowInfo, ShowSuccess, ShowWarning, ThrowError } from './notification.actions';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
import { EMPTY } from 'rxjs';
import { TokenRefreshSuccessful } from '../../security/state/authState.actions';

@State<NotificationModel>({
    name: 'error',
    defaults: {
        exception: null,
    },
})
@Injectable()
export class NotificationState {
    @Action(HandleApiResult)
    handleApiResult({ dispatch }: StateContext<NotificationModel>, action: HandleApiResult) {
        const result = action.payload.result;
        if (result.exception !== undefined) {
            return dispatch(new ThrowError(result.exception));
        }

        if (result.success !== undefined && !result.success) {
            if (result.message !== undefined && result.message.length > 0) {
                const warningMessage = `${ action.payload.message }<br />Message from server: ${ result.message }`;
                return dispatch(new ShowWarning(warningMessage));
            }
            return dispatch(new ShowWarning(action.payload.message));
        }

        return EMPTY;
    }

    @Action(ThrowError)
    throwError({ setState }: StateContext<NotificationModel>, action: ThrowError) {
        setState(
            patch({
                exception: action.exception,
            })
        );
    }

    @Action(ShowError)
    error(ctx: StateContext<NotificationModel>, action: ShowError) {
        return action.message;
    }

    @Action(ShowWarning)
    warning(ctx: StateContext<NotificationModel>, action: ShowWarning) {
        return action.message;
    }

    @Action(ShowSuccess)
    success({}: StateContext<NotificationModel>, action: ShowSuccess) {
        return action.message;
    }

    @Action(ShowInfo)
    info({}: StateContext<NotificationModel>, action: ShowSuccess) {
        return action.message;
    }

    @Selector()
    static getError(state: NotificationModel) {
        return state;
    }
}
